import React from 'react';
import { Link } from 'react-router-dom';

export default function HomePage() {
  return (
    <div>
      <section className="bg-gradient-to-r from-blue-600 to-purple-600 text-white py-32">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-6xl font-bold mb-6">Welkom bij StudentenCity</h1>
          <p className="text-2xl mb-8 opacity-90">Jouw hub voor studentenleven in Nederland</p>
          <div className="flex gap-4 justify-center">
            <Link to="/events" className="bg-white text-blue-600 px-8 py-4 rounded-full font-bold text-lg hover:bg-yellow-300 hover:text-blue-800 transition">
              Bekijk Evenementen
            </Link>
            <Link to="/register" className="border-2 border-white text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-blue-600 transition">
              Gratis Aanmelden
            </Link>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-center mb-12 text-gray-800">Wat bieden we?</h2>
          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            <div className="bg-blue-50 p-8 rounded-2xl hover:shadow-xl transition">
              <div className="text-4xl mb-4">🎉</div>
              <h3 className="text-2xl font-bold mb-4 text-gray-800">Evenementen</h3>
              <p className="text-gray-600">Introductiefeesten, borrels, workshops en netwerkevenementen door heel Nederland.</p>
            </div>
            <div className="bg-purple-50 p-8 rounded-2xl hover:shadow-xl transition">
              <div className="text-4xl mb-4">🏠</div>
              <h3 className="text-2xl font-bold mb-4 text-gray-800">Kamers</h3>
              <p className="text-gray-600">Vind je ideale studentenkamer via ons netwerk van woningbouwverenigingen.</p>
            </div>
            <div className="bg-green-50 p-8 rounded-2xl hover:shadow-xl transition">
              <div className="text-4xl mb-4">💰</div>
              <h3 className="text-2xl font-bold mb-4 text-gray-800">Kortingen</h3>
              <p className="text-gray-600">Exclusieve kortingen bij webshops, restaurants en diensten voor studenten.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
